import React from 'react';
import { Loader2 } from 'lucide-react';

const PublishModal = ({
  showPublishModal,
  publishName,
  setPublishName,
  localAssessmentConfig,
  changeSummary,
  setChangeSummary,
  setShowPublishModal,
  handlePublish,
  publishing
}) => {
  if (!showPublishModal) return null;

  return (
    <div className="fixed inset-0 bg-gray-950/40 dark:bg-black/70 flex items-center justify-center z-50">
      <div className="max-w-lg w-full overflow-hidden rounded-xl bg-white shadow-overlay ring-1 ring-gray-900/5 dark:bg-gray-800 dark:ring-white/10">
        <div className="flex items-start justify-between gap-4 border-b border-gray-100 px-6 py-4 dark:border-white/[0.06]">
          <h2 className="text-base font-semibold text-gray-900 dark:text-gray-50">Publish Assessment</h2>
        </div>

        <div className="px-6 py-5">
          <div className="mb-4 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3 dark:border-white/[0.06] dark:bg-white/[0.02]">
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Publishing will create a locked version <strong>(v1.0)</strong> that cannot be edited.
              To make changes after publishing, you'll need to create a new version.
            </p>
          </div>

          {/* Assessment Name */}
          <div className="mb-4">
            <label className="label">
              Assessment Name
            </label>
            <input
              type="text"
              value={publishName}
              onChange={(e) => setPublishName(e.target.value)}
              placeholder={localAssessmentConfig?.name || 'Enter assessment name'}
              className="input"
            />
            <p className="hint">Leave blank to keep current name</p>
          </div>

          {/* Change Summary */}
          <div>
            <label className="label">
              Change Summary <span className="text-xs font-normal text-gray-400 dark:text-gray-500">(optional)</span>
            </label>
            <textarea
              value={changeSummary}
              onChange={(e) => setChangeSummary(e.target.value)}
              placeholder="Describe the changes in this version..."
              className="input"
              rows="3"
            />
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-end gap-2 border-t border-gray-100 bg-gray-50/70 px-6 py-3.5 dark:border-white/[0.06] dark:bg-white/[0.02]">
          <button
            onClick={() => {
              setShowPublishModal(false);
              setChangeSummary('');
              setPublishName('');
            }}
            className="btn btn-secondary"
          >
            Cancel
          </button>
          <button
            onClick={handlePublish}
            disabled={publishing}
            className="btn btn-primary"
          >
            {publishing ? (
              <span className="flex items-center justify-center gap-2">
                <Loader2 className="w-4 h-4 animate-spin" />
                Publishing...
              </span>
            ) : (
              'Publish'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PublishModal;
